import './style/index.js';

import _Tag from './tag';

export * from './type';

export const Tag = _Tag;
export default Tag;
